'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { css, styled } from '@mui/material/styles';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { StackedNavList } from '../base/StackedNavList';
import { navCssClassNames } from '../navCssClassNames';
import { NavItem } from '../NavItem';
import { NavItemButton } from '../NavItemButton';
import { NavItemCollapse } from '../NavItemCollapse';
const navMinWidth = '15rem'; // arbitrary
const navMaxWidth = '19.25rem'; // figma spec
const StyledNav = styled('nav')(({ theme }) => css `
    grid-area: side-nav;

    min-width: ${navMinWidth};
    max-width: ${navMaxWidth};
    width: auto;
    background-color: ${theme.tokens.FuelColorWhite};
    display: block;
    padding-block: ${theme.tokens.FuelSpacing2};
    box-shadow: ${theme.tokens.FuelShadowMd};
    border-radius: ${theme.tokens.FuelBorderRadiusLg};
`);
export const SideNav = forwardRef(({ children, className, items, ...props }, ref) => (_jsx(StyledNav, { className: clsx(navCssClassNames.variantSide, 'SideNav-root', className), ref: ref, ...props, children: _jsx(StackedNavList, { className: navCssClassNames.list, children: children ?? items?.map(({ label, subNavigationItems, ...itemProps }, itemIndex) => (_jsx(NavItem, { children: subNavigationItems?.length ? (_jsx(NavItemCollapse, { ...itemProps, items: subNavigationItems, children: label })) : (_jsx(NavItemButton, { ...itemProps, orientation: 'side', children: label })) }, itemIndex))) }) })));
SideNav.displayName = 'SideNav';
